import { GridColDef, GridValueOptionsParams } from '@mui/x-data-grid-premium';
import { baseCell, currencyCell } from 'components/cells';
import {
  numberFilterOperators,
  filterOperators,
  dateFilterOperators,
  singleSelectFilterOperators
} from 'components/enhanced';
import { TFunction } from 'i18next';
import { Option } from 'shared/types/general';

export function UnapprovedMovementColumns(
  t: TFunction,
  types: string[],
  warehouses: string[],
  locations: Option[]
): GridColDef[] {
  const translationPrefix = 'entities.movement';

  const columns: GridColDef[] = [
    {
      field: 'quantity',
      headerName: t(`${translationPrefix}.moved_quantity`),
      type: 'number',
      editable: true,
      filterOperators: numberFilterOperators,
      width: 80,
      renderCell: baseCell
    },
    {
      field: 'product',
      headerName: t(`global.product`),
      filterOperators,
      width: 150,
      renderCell: baseCell
    },
    {
      field: 'description',
      headerName: t(`global.description`),
      filterOperators,
      width: 300,
      renderCell: baseCell
    },
    {
      field: 'product_batch',
      headerName: t(`${translationPrefix}.product_batch`),
      filterOperators,
      width: 150,
      editable: true,
      renderCell: baseCell
    },
    {
      field: 'expiration_date',
      headerName: t(`${translationPrefix}.expiration_date`),
      filterOperators: dateFilterOperators,
      width: 100,
      editable: true,
      renderCell: baseCell
    },
    {
      field: 'note_location',
      headerName: t(`${translationPrefix}.note_location`),
      width: 250,
      type: 'singleSelect',
      editable: true,
      sortable: false,
      valueOptions: (params: GridValueOptionsParams) =>
        locations
          .filter((location) => location.label === params.row.warehouse)
          .map((location) => location.code),
      filterOperators: singleSelectFilterOperators,
      valueGetter: (params) => params.row?.note_location
    },
    {
      field: 'product_notes',
      headerName: t(`entities.product.product_notes`),
      filterable: false,
      sortable: false,
      width: 200,
      renderCell: baseCell
    },
    {
      field: 'order_notes',
      headerName: t(`entities.product.purchase-request-notes`),
      filterable: false,
      sortable: false,
      width: 200,
      renderCell: baseCell
    },
    {
      field: 'supplier',
      headerName: t(`global.supplier`),
      filterOperators,
      width: 150,
      renderCell: baseCell
    },
    {
      field: 'timestamp',
      headerName: t(`${translationPrefix}.timestamp`),
      filterOperators: dateFilterOperators,
      width: 100,
      editable: true,
      renderCell: baseCell
    },
    {
      field: 'price',
      headerName: t(`${translationPrefix}.price`),
      filterable: false,
      sortable: false,
      type: 'number',
      width: 120,
      renderCell: currencyCell
    },
    {
      field: 'unit_price',
      headerName: t(`${translationPrefix}.unapproved-unit_price`),
      filterOperators,
      editable: true,
      type: 'number',
      width: 120,
      renderCell: currencyCell
    },
    {
      field: 'warehouse',
      headerName: t(`global.warehouse`),
      type: 'singleSelect',
      valueOptions: warehouses,
      width: 250,
      editable: true,
      filterOperators: singleSelectFilterOperators,
      renderCell: baseCell
    },
    {
      field: 'movement_type',
      headerName: t(`${translationPrefix}.type`),
      type: 'singleSelect',
      valueOptions: types,
      width: 250,
      editable: true,
      filterOperators: singleSelectFilterOperators,
      renderCell: baseCell
    },
    {
      field: 'order_code',
      headerName: t(`entities.movement.order_code`),
      filterOperators,
      editable: true,
      width: 250,
      renderCell: baseCell
    },
    {
      field: 'transport_document_code',
      headerName: t(`${translationPrefix}.transport_document`),
      filterOperators,
      width: 200,
      editable: true,
      renderCell: baseCell
    },
    {
      field: 'transport_document_date',
      headerName: t(`${translationPrefix}.transport_document_date`),
      filterOperators: dateFilterOperators,
      width: 100,
      editable: true,
      renderCell: baseCell
    },
    {
      field: 'created_by',
      headerName: t(`${translationPrefix}.created_by`),
      filterOperators,
      width: 130,
      renderCell: baseCell
    },
    {
      field: 'scanned_code',
      headerName: t(`${translationPrefix}.scanned_code`),
      filterable: false,
      sortable: false,
      width: 200,
      renderCell: baseCell
    }
  ];

  return columns;
}
